 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"dashy": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"dashy": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-04b343d1":"d10f4cdb","chunk-051d7c14":"062facb3","chunk-0eec46d7":"f29ab36b","chunk-16419cba":"afcd56ab","chunk-17548345":"4e95adba","chunk-20fd6e9e":"42efc6fb","chunk-2bf05644":"bc64c317","chunk-2ee06ca8":"62bde747","chunk-36fb5c32":"ee06561c","chunk-38b31ef9":"c704a17e","chunk-3df90975":"359e0c90","chunk-3f199ee2":"02a9e15a","chunk-4ae56f14":"9cf9c977","chunk-4bfbb1e8":"db9b7fd9","chunk-4fcd5d80":"c8b29503","chunk-50f31ec3":"45af5b52","chunk-1c683ba0":"94983320","chunk-1ec1b1aa":"b3fe0bea","chunk-2d225b78":"a44479d2","chunk-48dc0af1":"489e1e78","chunk-4b6e01c6":"2a50ede9","chunk-665346fe":"f683fb55","chunk-71fd7141":"b3e3c16d","chunk-91f9933a":"ba3b3a8a","chunk-a08d5c64":"a93126c1","chunk-5d3daeec":"c47249cd","chunk-6604570a":"ad4bd2ec","chunk-670b2b86":"97e25fc8","chunk-687e314e":"ebd69cd5","chunk-724820ea":"8e67da9c","chunk-784d207a":"28049ba0","chunk-82ef841e":"c1f1b4ee","chunk-897867a6":"6e994655","chunk-93e7ea42":"e9171844","chunk-ac998856":"6ec5704b","chunk-e80d132e":"7bb9f66a","chunk-e93eb2f0":"c15985a9","chunk-ed3daf8c":"2ca261b4","chunk-ee1427b4":"b7620b59"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-04b343d1":1,"chunk-051d7c14":1,"chunk-0eec46d7":1,"chunk-16419cba":1,"chunk-17548345":1,"chunk-20fd6e9e":1,"chunk-2bf05644":1,"chunk-2ee06ca8":1,"chunk-36fb5c32":1,"chunk-38b31ef9":1,"chunk-3df90975":1,"chunk-3f199ee2":1,"chunk-4ae56f14":1,"chunk-4bfbb1e8":1,"chunk-4fcd5d80":1,"chunk-1c683ba0":1,"chunk-1ec1b1aa":1,"chunk-48dc0af1":1,"chunk-4b6e01c6":1,"chunk-665346fe":1,"chunk-71fd7141":1,"chunk-91f9933a":1,"chunk-a08d5c64":1,"chunk-5d3daeec":1,"chunk-6604570a":1,"chunk-670b2b86":1,"chunk-687e314e":1,"chunk-724820ea":1,"chunk-784d207a":1,"chunk-82ef841e":1,"chunk-897867a6":1,"chunk-93e7ea42":1,"chunk-ac998856":1,"chunk-e80d132e":1,"chunk-e93eb2f0":1,"chunk-ed3daf8c":1,"chunk-ee1427b4":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-04b343d1":"49b9ef8e","chunk-051d7c14":"6fea770a","chunk-0eec46d7":"90cf07cd","chunk-16419cba":"72bd8456","chunk-17548345":"a21d5968","chunk-20fd6e9e":"5aaf7cba","chunk-2bf05644":"262be67e","chunk-2ee06ca8":"0a2cd431","chunk-36fb5c32":"a64c098d","chunk-38b31ef9":"7b3c2311","chunk-3df90975":"0ad2f1c3","chunk-3f199ee2":"7c8c2f30","chunk-4ae56f14":"9e53f5b9","chunk-4bfbb1e8":"5d01068d","chunk-4fcd5d80":"c1e04cdf","chunk-50f31ec3":"31d6cfe0","chunk-1c683ba0":"d6684378","chunk-1ec1b1aa":"98a4aa99","chunk-2d225b78":"31d6cfe0","chunk-48dc0af1":"98a4aa99","chunk-4b6e01c6":"7aa83618","chunk-665346fe":"b5b0de24","chunk-71fd7141":"2ca1d591","chunk-91f9933a":"3e780d1f","chunk-a08d5c64":"f1c873fc","chunk-5d3daeec":"0adbc3b9","chunk-6604570a":"1344d498","chunk-670b2b86":"b73f2acc","chunk-687e314e":"598863ad","chunk-724820ea":"8e5b7c8e","chunk-784d207a":"edab57b2","chunk-82ef841e":"68a4a897","chunk-897867a6":"ac41b81a","chunk-93e7ea42":"fbd3c02c","chunk-ac998856":"0c61ab58","chunk-e80d132e":"ccf83212","chunk-e93eb2f0":"8d9c94f0","chunk-ed3daf8c":"683ae2b7","chunk-ee1427b4":"e1ddbf69"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
